import type { ReactNode } from "react";

import { cn } from "@flare/ui";

export function InputsContainer({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("mx-auto max-w-[520px]", className)}>{children}</div>
  );
}
